import { Plus } from "@untitledui/icons";
import { useAddToCampaignUrl } from "@/api/tiktok-ads";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

// Renders nothing while TikTok Ads is not connected, separator included.
export const AddToCampaignMenuItem = ({ withSeparator = false }: { withSeparator?: boolean }) => {
  const addToCampaignUrl = useAddToCampaignUrl();
  if (!addToCampaignUrl) return null;

  return (
    <>
      {withSeparator && <DropdownMenuSeparator />}
      <DropdownMenuItem asChild className="gap-2 cursor-pointer">
        <a href={addToCampaignUrl} target="_blank" rel="noopener noreferrer">
          <Plus className="w-4 h-4 text-fg-quaternary" />
          <span className="text-secondary text-sm">Add to Campaign</span>
        </a>
      </DropdownMenuItem>
    </>
  );
};
